import { http } from '../services';

class EventoService {
    eventoForm() {
        return http.get('/eventos/form');
    }

    async getAll() {
        const eventos = await http.get('/eventos');
        return eventos;
    }
    async getEventoPeloNome(nome) {
        return this.getAll({
            pageIndex: 1,
            rowsPerPage: 5,
            columnSort: 1,
            orderSort: 'ASC',
            searchIndex: 1,
            searchText: nome,
            searchOperator: 'LIKE',
        });
    }

    async getEventosPeloAno(ano) {
        return http.get('/eventos/ano', {
            ano,
        });
    }

    getEvento(codigo) {
        return http.get(`/eventos/${codigo}`);
    }

    getEventosCertificados() {
        return http.get('/evento/todos-eventos-certificados');
    }

    getEventosFinalizados() {
        return http.get('/eventos/eventos-finalizados');
    }

    getEventosEmAndamento() {
        return http.get('/eventos/eventos-andamento');
    }

    save(evento) {
        return http.post('/eventos', evento);
    }

    update(evento) {
        return http.put('/eventos', evento);
    }

    delete(evento) {
        return http.delete('/eventos', evento);
    }
}

const eventoService = new EventoService();
export default eventoService;
